var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledInput',_vm._b({on:{"input":function($event){return _vm.update($event)}},model:{value:(_vm.userValue),callback:function ($$v) {_vm.userValue=$$v},expression:"userValue"}},'LabeledInput',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }